import * as React from "react";
function SvgCross(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 21.208a2 2 0 01-2-2v-4H5a2 2 0 01-2-2v-2a2 2 0 012-2h4v-4a2 2 0 012-2h2a2 2 0 012 2v4h4a2 2 0 012 2v2a2 2 0 01-2 2h-4v4a2 2 0 01-2 2h-2zm0-8H5v-2h6v-6h2v6h6v2h-6v6h-2v-6z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgCross);
export default ForwardRef;
